<template>

  <section id="cidade-atendida" class="d-flex align-items-center cidade-atendida">
      <div class="container">
        <div class="row">

          <div class="icon-box" data-aos="fade-up" data-aos-delay="200">
            <div class="d-flex justify-content-start flex-fill mb-4" data-aos="fade-right" data-aos-delay="150">
              <a href="/">
                <img src="../assets/img/logo.png" alt="" class="img-fluid" style="width: 180px; margin-left: -7px;">
              </a>
            </div>

            <div class="col-lg-12 d-flex flex-column justify-content-center mb-4">
              <h3 class="pb-2 text-center" data-aos="fade-up">CIDADES ATENDIDAS</h3>
              <br>
              <div>Total de cidades atendidas: <strong>{{ totalCities }}</strong></div>
              <br>
              <select v-model="selectedState" @change="filterCities" size="0">
                <option value="">Selecione um estado</option>
                <option v-for="state in states" :value="state.id" :key="state.id">{{ state.name }}</option>
              </select>
              <br>
              <div v-if="selectedState">Total de cidades do estado selecionado: <strong>{{ totalCitiesInState }}</strong></div>
              <br>
              <div v-if="totalCitiesInState > 0"><strong>Código IBGE - Nome da Cidade</strong>
                <ul>
                  <li v-for="city in filteredCities" :key="city.id">
                  {{ city.id }} - {{ city.name }}
                  </li>
                </ul>
              </div>
            </div>

            <br>
            <div>
              <a class="getstarted align-items-center justify-content-center" href="/">Voltar</a>
            </div>
          </div>

        </div>
      </div>
  </section>

</template>

<script>
export default {
  name: 'CidadeComp',

  data: function () {
    return {
      selectedState: '',
      states: [],
      cities: []
    }
  },

  computed: {
    filteredCities: function () {
      return this.cities.filter(city => city.state === this.selectedState)
    },
    totalCitiesInState: function () {
      return this.filteredCities.length
    },
    totalCities: function () {
      return this.cities.length
    }
  },

  methods: {
    filterCities: function () {
      this.selectedCity = ''
    }
  },

  created: function () {
    /*
    const jsonUrl = 'http://localhost:8080/municipios_estados.json'
    */
    const jsonUrl = 'https://sigame.digital/json/municipios_estados.json'

    fetch(jsonUrl)
      .then(response => response.json())
      .then(data => {
        this.states = data.states
        this.cities = data.cities
        /* console.log(JSON.stringify(this.states, null, 4)) */
      })
  }

}
</script>

<style scoped lang="scss">
.cidade-atendida {
  padding-top: 0;
  background-color: #f7f8fa;
  padding: 9vh 1vw 15%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.cidade-atendida .icon-box {
  padding: 30px;
  position: relative;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 0 29px 0 rgba(68, 88, 144, 0.12);
  transition: box-shadow 0.3s ease;
  border-radius: 8px; /* 40px; */
  z-index: 1;
}

.cidade-atendida.content {
  padding: 0;
}

.cidade-atendida.content h3 {
  font-weight: 700;
  font-size: 34px;
  color: $color-base;
}
.cidade-atendida.content p {
  margin-bottom: 0;
}

.cidade-atendida select {
  padding: 10px;
  font-size: 18px;
  border: 2px solid #ccc;
  border-radius: 5px;
}

.cidade-atendida ul {
  list-style-type: circle;
  padding: 0;
}

.cidade-atendida li {
  margin: 5px 0;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #f9f9f9;
  display: flex;
  align-items: center;
  font-weight: bold;
}

</style>
